import { useEffect } from 'react';

function AdSense({ 
  slot = '0000000000',
  format = 'auto',
  responsive = true,
  style = {},
  className = '',
  label = true
}) {
  useEffect(() => {
    try {
      // Push ad to AdSense
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, []);

  return (
    <div className={`adsense-container ${className}`}>
      {label && (
        <div className="ad-label">
          <span className="ad-label-text">Sponsored · Helps keep Its Written AI free</span>
        </div>
      )}
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          textAlign: 'center',
          ...style
        }}
        data-ad-client="ca-pub-0000000000000000"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? 'true' : 'false'}
      />
    </div>
  );
}

export default AdSense;
